import { useEffect } from 'react';

import { H3, P2 } from '../../../styles/FontStyles';

import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../app/hooks';
import { Flexed } from '../../../styles/GlobalComponents';
import { colors } from '../../../styles/GlobalStyles';
import { Overlay } from '../Overlay';
import { getMyHubsEntryOne } from '../Portfolio.actions';

import { GardianItem } from './GardianItem';

export const GuardianSummary = () => {
  const dispatch = useDispatch();

  const { entryOne } = useAppSelector((state) => state.portfolio);

  useEffect(() => {
    dispatch(getMyHubsEntryOne());
  }, [dispatch]);

  useEffect(() => {}, [entryOne]);

  return (
    <>
      <Flexed mb='40' center between rowSM>
        <H3 mbSM='10' color={colors.primary900}>
          My Packages
        </H3>
      </Flexed>

      <div>
        {entryOne?.orders?.map((item: any, index: number) => (
          <GardianItem key={index} item={item} />
        ))}
      </div>

      {entryOne?.orders?.length === 0 && (
        <P2 center color={colors.neutral500}>
          No data available
        </P2>
      )}

      <Overlay />
    </>
  );
};
